<!--
 * @Description: 登录
 * @Author: huangshiwen
 * @Date: 2022-05-30 13:40:58
 * @LastEditTime: 2025-12-09 14:14:41
-->
<template>
  <div div style="background:#fff">
    <div class="yygh-title">预约挂号</div>
    <Common>
      <template slot="cd">
        <CdhospitalBookTab currentIndex="3" />
        <CdhospitalMachineBook />
      </template>
      <template slot="sz">
        <SzhospitalBookTab currentIndex="3" />
        <SzhospitalMachineBook />
      </template>
      <template slot="hf">
        <HfhospitalBookTab currentIndex="3" /> <HfhospitalMachineBook />
      </template>
    </Common>
  </div>
</template>

<script>
import CdhospitalMachineBook from '@/components/hospitalMachineBook/cdhospitalMachineBook'
import SzhospitalMachineBook from '@/components/hospitalMachineBook/szhospitalMachineBook'
import HfhospitalMachineBook from '@/components/hospitalMachineBook/hfhospitalMachineBook'
import CdhospitalBookTab from '@/components/hospitalBookTab/cdhospitalBookTab'
import SzhospitalBookTab from '@/components/hospitalBookTab/szhospitalBookTab'
import HfhospitalBookTab from '@/components/hospitalBookTab/hfhospitalBookTab'
export default {
  components: {
    CdhospitalMachineBook,
    SzhospitalMachineBook,
    HfhospitalMachineBook,
    SzhospitalBookTab,
    CdhospitalBookTab,
    HfhospitalBookTab,
  },

  data() {
    return {}
  },
  created() {},
}
</script>
<style lang="less" scoped>
.yygh-title {
  text-align: center;
  font-size: 30px;
  line-height: 30px;
  padding-top: 50px;
  background: #fff;
}
.m-screen-mobile .yygh-title {
  padding-top: 0.8rem;
  font-size: 0.45rem !important;
  text-align: center;
  line-height: 0.46rem !important;
}
</style>
